import z from 'zod';
import { DeployParamKind } from '@redviking/argonaut-util/src/mes/deployParamKind';
import { appletVariableValueSchema } from './var.zod';
import { schemaVersionSchema } from './schemaVersion';

const deployParamValueBase = z.object({
    kind: z.nativeEnum(DeployParamKind),
    val: z.unknown(),
    schemaVersion: schemaVersionSchema,
});

const sparkplugParamValueSchema = z.object({
    nodeId: z.string().min(1),
    version: z.string().min(1),
    groupId: z.string().min(1),
    deviceId: z.string().min(1),
});
export type SparkplugParamValue = z.infer<typeof sparkplugParamValueSchema>;

export const deployParamValueSchema = z.discriminatedUnion('kind', [
    deployParamValueBase.extend({
        kind: z.literal(DeployParamKind.localVarValue),
        /**
         * if true, this value should be used (as opposed to the default value in the applet).
         * This is the only deploy param kind that can opt out.
         * All other kinds are always required
         */
        enabled: z.boolean().default(true),
        val: appletVariableValueSchema,
    }),
    deployParamValueBase.extend({
        kind: z.literal(DeployParamKind.location),
        val: z.string().uuid(),
    }),
    deployParamValueBase.extend({
        kind: z.literal(DeployParamKind.asset),
        val: z.string().uuid(),
    }),
    // TODO: THIS DEVICE STRING NEEDS TO BE AN OBJECT
    deployParamValueBase.extend({
        kind: z.literal(DeployParamKind.sparkplugNodeCfg),
        val: sparkplugParamValueSchema,
    }),
]);
export type DeployParamValue_v4 = z.infer<typeof deployParamValueSchema>;
